export const signIn = async (signUpInfo, setSignUpInfo, setIsAuthenticated) => {
    try{
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
        const response = await fetch(`${API_BASE_URL}/signin`, {
            method:'POST',
            credentials:'include',
            headers:{
                'Content-Type': 'application/json',
                "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body:JSON.stringify({ email:signUpInfo.email, password:signUpInfo.password }),
        });
        const result = await response.json();
        console.log('response: '+ JSON.stringify(result))
        if(JSON.stringify(result) === `{"message":"Invalid email or password"}`){
            return ('invalid credentials')
        }
        return('success')
    }
    catch(error){
        console.error('Error: ', error)
        return ('server error') 
    }
}